// ── Canonical module list for the role-permission matrix ─────────────────────
// Mirrors ca-backend/config/rolePermissions.js (MODULES). Keep the two in sync.
//
// `key`   — matches role_permissions.module and the sidebar item `module` key
// `label` — shown in Settings → User Roles
// `nav`   — true when this key also controls a top-level sidebar item
// `workspace` — true for paid modules gated primarily by user_module_access

export const PERMISSION_MODULES = [
  { key: 'dashboard', label: 'Dashboard', nav: true },
  { key: 'crm',       label: 'CRM',       nav: true },
  { key: 'clients',   label: 'Clients',   nav: true },
  { key: 'services',  label: 'Services',  nav: true },
  { key: 'tasks',     label: 'Tasks',     nav: true },
  { key: 'finance',   label: 'Finance',   nav: true },
  { key: 'accounting',label: 'Accounting', nav: true },
  { key: 'renewals',  label: 'Renewals',  nav: true },
  { key: 'reports',   label: 'Reports',   nav: true },
  { key: 'people',    label: 'People',    nav: true },
  { key: 'settings',  label: 'Settings',  nav: true },
  { key: 'hr',        label: 'HR',        workspace: true },
  { key: 'referrals', label: 'Referrals', workspace: true },
];

export const PERMISSION_MODULE_KEYS = PERMISSION_MODULES.map(m => m.key);

// Fired after an admin changes a role's permissions so open usePermissions()
// consumers re-fetch instead of holding a stale cache for the whole session.
export const PERMISSIONS_UPDATED_EVENT = 'permissions-updated';
